module.exports = __webpack_public_path__ + "static/media/figma.1a79a986.svg";